// **The spectate variant** (`client-rounds-review`'s "a spectate variant composes the graded
// review for a projected screen" requirement; `tournament-big-screen` design **D12**).
//
// A composable export, not a fork: this is `RoundsReview` with `spectate` set, and nothing
// else. Every property the spec asks of it — one renderer, one trace-reading path, the field
// as the default camera, the bounded playhead-ordered rail, the eliminated counter, the
// back-to-the-field control, no player affordance — is either `RoundsReview`'s own behaviour
// already or is gated behind `spectate` inside that same component. Keeping the two
// substitutable at the type level (`SpectateViewProps` is a narrowed `RoundsReviewProps`) is
// what makes "no second copy of the graded subject model" a property of the source rather than
// a claim about it.
//
// Constructs nothing of its own: no HTTP client, no credential store, no GPU context. Every
// seam — the reader, the renderer factory, the roster, the callbacks — is the composition
// root's to inject, exactly as `RoundsReview` already requires.

import { RoundsReview, type RoundsReviewProps } from './RoundsReview';

export type SpectateViewProps = Omit<
  RoundsReviewProps,
  'spectate' | 'onOpenStandings' | 'viewerState' | 'onViewerStateChange'
>;

export function SpectateView(props: SpectateViewProps) {
  return <RoundsReview {...props} spectate />;
}
